import { jsx as i } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { Toaster as m } from "sonner";
import a from "../Icon/Icon.mjs";
import { cn as t } from "../../lib/utils.mjs";
import { ToastVariants as r } from "./ToastVariants.mjs";
const l = c(
  ({ toastOptions: o = {}, closeButton: n = !1, dir: e = "ltr" }, s) => /* @__PURE__ */ i(
    m,
    {
      ref: s,
      closeButton: n,
      toastOptions: {
        unstyled: !0,
        ...o,
        classNames: {
          success: t(r({ variant: "success" })),
          error: t(r({ variant: "error" })),
          warning: t(r({ variant: "warning" })),
          info: t(r({ variant: "info" })),
          title: t(r({ variant: "title" })),
          toast: t(r({ variant: "toast" })),
          icon: t(r({ variant: "icon" })),
          description: t(r({ variant: "description" })),
          closeButton: t(r({ variant: "closeButton" })),
          actionButton: t(r({ variant: "actionButton" }))
        }
      },
      dir: e,
      icons: {
        success: /* @__PURE__ */ i(
          a,
          {
            width: 5,
            height: 5,
            variant: "white",
            icon: "material-symbols:check-circle-rounded"
          }
        ),
        error: /* @__PURE__ */ i(
          a,
          {
            width: 5,
            height: 5,
            variant: "white",
            icon: "material-symbols:dangerous-outline-rounded"
          }
        ),
        info: /* @__PURE__ */ i(
          a,
          {
            width: 5,
            height: 5,
            variant: "white",
            icon: "material-symbols:error-rounded"
          }
        ),
        warning: /* @__PURE__ */ i(
          a,
          {
            width: 5,
            height: 5,
            variant: "white",
            icon: "material-symbols:warning-rounded"
          }
        )
      }
    }
  )
);
l.displayName = "Snackbar";
export {
  l as default
};
//# sourceMappingURL=Toast.mjs.map
